import { render } from "./KeyVaultConfigurationForm.vue?vue&type=template&id=0c38dc54&ts=true"
import script from "./KeyVaultConfigurationForm.vue?vue&type=script&lang=ts"
export * from "./KeyVaultConfigurationForm.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__